import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 11,
	viewBox: "0 0 14 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3738 3.68702L10.6813 0.994522C10.2163 0.529522 9.40625 0.859522 9.40625 1.52702V3.46952H4.15625C2.08625 3.46952 0.40625 5.14952 0.40625 7.21952V9.46952C0.40625 9.88202 0.74375 10.2195 1.15625 10.2195C1.56875 10.2195 1.90625 9.88202 1.90625 9.46952V7.21952C1.90625 5.98202 2.91875 4.96952 4.15625 4.96952H9.40625V6.91202C9.40625 7.57952 10.2163 7.91702 10.6888 7.44452L13.3813 4.75202C13.6663 4.45952 13.6663 3.97952 13.3738 3.68702Z",
		fill: "#1D1D1D"
	})
});
export default SvgBack;
